/* Inline create control for the workspace menu and Profile. Hidden when createClosed. */

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useWorkspace } from '../contexts/WorkspaceContext';

export default function CreateClientWorkspaceControl({ usage }) {
  const navigate = useNavigate();
  const { createWorkspace } = useWorkspace();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(null);

  if (!usage || usage.createClosed) return null;

  if (!usage.canCreateWorkspace && !usage.isOwner) return null;

  if (!usage.canCreateWorkspace) {
    const owned = usage.workspacesOwned ?? 0;
    const limit = usage.workspaceLimit ?? 0;
    return (
      <Link
        to="/billing"
        style={{
          display: 'block',
          padding: '8px 10px',
          fontSize: '13px',
          color: 'var(--muted)',
          textDecoration: 'none',
          fontFamily: "'Archivo', sans-serif",
        }}
      >
        {owned} of {limit} workspaces · Upgrade
      </Link>
    );
  }

  async function handleCreate() {
    const trimmed = name.trim();
    if (trimmed.length < 2 || pending) return;
    setPending(true);
    setError(null);
    try {
      await createWorkspace(trimmed);
      setName('');
      setOpen(false);
      navigate('/onboarding?fresh=1');
    } catch (err) {
      setError(err.message || 'Could not create workspace');
    } finally {
      setPending(false);
    }
  }

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        disabled={pending}
        style={{
          width: '100%',
          padding: '8px 10px',
          background: 'transparent',
          color: 'var(--ink)',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: 500,
          textAlign: 'left',
          fontFamily: "'Archivo', sans-serif",
        }}
      >
        + New client workspace
      </button>
    );
  }

  return (
    <div style={{ padding: '4px 6px 8px' }} onClick={(e) => e.stopPropagation()}>
      <input
        type="text"
        className="fb-input"
        value={name}
        autoFocus
        placeholder="Client name"
        disabled={pending}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleCreate();
          } else if (e.key === 'Escape') {
            e.preventDefault();
            setOpen(false);
            setName('');
            setError(null);
          }
        }}
        style={{ width: '100%', fontSize: '13px', marginBottom: '6px' }}
      />
      <button
        type="button"
        className="inbox-pill-btn-primary"
        onClick={handleCreate}
        disabled={pending || name.trim().length < 2}
        style={{ width: '100%' }}
      >
        {pending ? 'Creating…' : 'Create'}
      </button>
      {error && (
        <p style={{ color: 'var(--danger, #b91c1c)', fontSize: '12px', margin: '6px 0 0' }}>{error}</p>
      )}
    </div>
  );
}
